module.exports = __webpack_public_path__ + "img/icn-structered support.ddb8319e.svg";